<template>
  <form
    v-loading="loading"
    @submit.prevent="create"
  >
    <b-modal
      ref="modal"
      :visible="true"
      :title="$t('Create object', {object: this.$tc('Users', 1).toLowerCase()})"
      @hide="close"
    >
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>{{ $tc('Accounts', 1) }}</label>
            <app-account-dropdown v-model="model.account" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label>{{ $t('Email') }}</label>
            <input
              v-model="model.email"
              type="email"
              class="form-control"
              required
            >
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label>{{ $t('Password') }}</label>
            <input
              v-model="model.password"
              type="password"
              class="form-control"
              required
              minlength="6"
            >
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label>{{ $t('First name') }}</label>
            <input
              v-model="model.firstName"
              type="text"
              class="form-control"
              required
              minlength="3"
            >
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label>{{ $t('Last name') }}</label>
            <input
              v-model="model.lastName"
              type="text"
              class="form-control"
              required
              minlength="3"
            >
          </div>
        </div>
      </div>
      <div class="form-group">
        <input
          id="account-create-form-admin"
          v-model="model.isAdmin"
          type="checkbox"
        >
        <label for="account-create-form-admin">{{ $tc('Admins', 1) }}?</label>
      </div>
      <div class="form-group">
        <input
          id="account-create-form-enabled"
          v-model="model.enabled"
          type="checkbox"
        >
        <label for="account-create-form-enabled">{{ $t('Active') }}?</label>
      </div>
      <template slot="modal-footer">
        <button
          type="submit"
          class="btn btn-primary"
        >
          {{ $t('Create') }}
        </button>
        <button
          type="button"
          class="btn btn-secondary"
          @click.prevent="close"
        >
          {{ $t('Close') }}
        </button>
      </template>
    </b-modal>
  </form>
</template>

<script>
import UserModel from '../models/UserModel';
import UserService from '../services/UsersService';
import AppAccountDropdown from '../components/accounts/AccountDropDown.vue';
import UsersRoleModel from '../models/UsersRoleModel';

export default {
  name: 'AppPageUserCreate',
  components: { AppAccountDropdown },
  data() {
    return {
      model: UserModel.getDefaults(),
      loading: false,
    };
  },
  computed: {
    roles() {
      const roles = {};
      roles[UsersRoleModel.ROLE_MANAGER] = this.$tc('Managers', 1);
      roles[UsersRoleModel.ROLE_ADMIN] = this.$tc('Admins', 1);
      return roles;
    },
  },
  methods: {
    create() {
      this.loading = true;
      const data = UserModel.toApiRequest(this.model);
      UserService.create(data).then(() => {
        this.$toastr.success(this.$t('Action', { object: this.$tc('Users', 1), action: this.$t('created') }), this.$t('Success'));
        this.close();
      }).catch(error => {
        this.$toastr.error(error.message, this.$t('Error'));
        this.loading = false;
      });
    },
    close() {
      this.$router.back();
    },
  },
};
</script>
